import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const UpdateSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default UpdateSVG;
